// src/components/Layout/Navbar.jsx — Thème Élégance Africaine
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore, useCartStore } from '../../context/store';

export default function Navbar() {
  const { user, isAuthenticated, logout, isAdmin } = useAuthStore();
  const count = useCartStore(s => s.count());
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => setMenuOpen(false), [pathname]);

  const isHome = pathname === '/';

  return (
    <header style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 'var(--z-dropdown)',
      height: scrolled ? 64 : 72,
      background: isHome && !scrolled ? 'rgba(45,15,40,.85)' : 'rgba(253,246,236,.95)',
      backdropFilter: 'blur(12px)',
      borderBottom: scrolled ? '1px solid var(--creme-dark)' : '1px solid transparent',
      boxShadow: scrolled ? 'var(--shadow-sm)' : 'none',
      transition: 'all .3s var(--ease)',
      display: 'flex', alignItems: 'center',
    }}>
      <div style={{ width: '100%', maxWidth: 1320, margin: '0 auto', padding: '0 var(--space-xl)', display: 'flex', alignItems: 'center', gap: 'var(--space-xl)' }}>

        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', flexShrink: 0 }}>
          <div style={{ width: 36, height: 36, background: 'linear-gradient(135deg, var(--prune) 0%, var(--prune-light) 100%)', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Georgia,serif', fontSize: 14, fontWeight: 600, color: 'var(--or)', boxShadow: 'var(--shadow-prune)' }}>FL</div>
          <span style={{ fontFamily: 'var(--font-display)', fontSize: 18, fontWeight: 300, letterSpacing: '.2em', color: isHome && !scrolled ? 'var(--creme)' : 'var(--prune-dark)' }}>FABI LUXE</span>
        </Link>

        {/* Navigation */}
        <nav style={{ display: 'flex', gap: 'var(--space-lg)', flex: 1, justifyContent: 'center' }}>
          {[
            { to: '/boutique', label: 'Boutique' },
            { to: '/boutique?categorie=wax', label: 'Wax' },
            { to: '/boutique?categorie=boubou', label: 'Boubou' },
            { to: '/boutique?categorie=bazin', label: 'Bazin' },
            { to: '/boutique?categorie=accessoires', label: 'Accessoires' },
          ].map(n => (
            <Link key={n.to} to={n.to} style={{
              fontSize: 12, fontWeight: 400, letterSpacing: '.1em', textTransform: 'uppercase',
              color: isHome && !scrolled ? 'rgba(253,246,236,.8)' : 'var(--gris)',
              textDecoration: 'none', transition: 'color .2s',
              fontFamily: 'var(--font-body)',
            }}
              onMouseEnter={e => e.target.style.color = isHome && !scrolled ? 'var(--or-light)' : 'var(--prune)'}
              onMouseLeave={e => e.target.style.color = isHome && !scrolled ? 'rgba(253,246,236,.8)' : 'var(--gris)'}
            >{n.label}</Link>
          ))}
        </nav>

        {/* Actions */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-md)', flexShrink: 0 }}>
          {isAuthenticated ? (
            <>
              {isAdmin && isAdmin() && (
                <Link to="/admin" style={{ fontSize: 11, fontFamily: 'var(--font-mono)', textTransform: 'uppercase', letterSpacing: '.08em', color: 'var(--prune)', background: 'rgba(74,25,66,.1)', padding: '5px 12px', borderRadius: 'var(--radius-full)', textDecoration: 'none', border: '1px solid rgba(74,25,66,.2)' }}>Admin</Link>
              )}
              <Link to="/compte" style={{ fontSize: 12, color: isHome && !scrolled ? 'rgba(253,246,236,.8)' : 'var(--gris)', textDecoration: 'none' }}>
                👤 {user?.nom?.split(' ')[0]}
              </Link>
              <button onClick={() => { logout(); navigate('/'); }} style={{ fontSize: 12, color: 'var(--gris-mid)', background: 'none', border: 'none', cursor: 'pointer' }}>Quitter</button>
            </>
          ) : (
            <>
              <Link to="/connexion" style={{ fontSize: 13, color: isHome && !scrolled ? 'rgba(253,246,236,.8)' : 'var(--gris)', textDecoration: 'none' }}>Connexion</Link>
              <Link to="/inscription" style={{ fontSize: 13, fontWeight: 600, color: 'var(--or-dark)', background: 'rgba(201,168,76,.12)', border: '1px solid rgba(201,168,76,.3)', padding: '7px 16px', borderRadius: 'var(--radius-full)', textDecoration: 'none' }}>S'inscrire</Link>
            </>
          )}

          {/* Panier */}
          <Link to="/panier" style={{ position: 'relative', width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', color: isHome && !scrolled ? 'var(--creme)' : 'var(--prune-dark)', textDecoration: 'none', fontSize: 20 }}>
            🛍
            {count > 0 && (
              <span style={{ position: 'absolute', top: 2, right: 2, minWidth: 18, height: 18, background: 'var(--prune)', color: 'var(--or)', borderRadius: 'var(--radius-full)', fontSize: 10, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px', fontFamily: 'var(--font-mono)' }}>{count}</span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}
